import { render, staticRenderFns } from "./mGameTable.vue?vue&type=template&id=10f677c0&scoped=true"
import script from "./mGameTable.vue?vue&type=script&lang=js"
export * from "./mGameTable.vue?vue&type=script&lang=js"
import style0 from "./mGameTable.vue?vue&type=style&index=0&id=10f677c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f677c0",
  null
  
)

export default component.exports